import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=47f588ea&scoped=true"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=47f588ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f588ea",
  null
  
)

export default component.exports